import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Select, Space } from "antd";
import { toast } from "react-toastify";
import Popup from "../../Helpers/Popup/Popup";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";
import trans from "../../../utils";
import { useGetAllPOIsQuery } from "../../../Redux/service/POIS/POIs";
import {
	useGetShiftPoisQuery,
	useAddShiftPoisMutation,
	useRemoveShiftPoiMutation,
} from "../../../Redux/service/Technician/ShiftPois";

export default function ShiftPoiPopup({ technicianId, name, onClose }) {
	const [selectedStartPois, setSelectedStartPois] = useState([]);
	const [selectedEndPois, setSelectedEndPois] = useState([]);

	const { data: allPoisData } = useGetAllPOIsQuery(
		{ page: 1, limit: 10000 },
		{ refetchOnMountOrArgChange: true }
	);

	const { data: startPoisData, refetch: refetchStart } = useGetShiftPoisQuery(
		{ technicianId, scope: "START_ONLY" },
		{ skip: !technicianId, refetchOnMountOrArgChange: true }
	);

	const { data: endPoisData, refetch: refetchEnd } = useGetShiftPoisQuery(
		{ technicianId, scope: "END_ONLY" },
		{ skip: !technicianId, refetchOnMountOrArgChange: true }
	);

	const [addShiftPois] = useAddShiftPoisMutation();
	const [removeShiftPoi] = useRemoveShiftPoiMutation();

	useEffect(() => {
		if (startPoisData?.data) {
			setSelectedStartPois(
				startPoisData.data
					.filter((item) => item.isActive)
					.map((item) => item.poiId)
			);
		}
	}, [startPoisData]);

	useEffect(() => {
		if (endPoisData?.data) {
			setSelectedEndPois(
				endPoisData.data
					.filter((item) => item.isActive)
					.map((item) => item.poiId)
			);
		}
	}, [endPoisData]);

	const poiOptions = (allPoisData?.data || [])
		.filter((poi) => poi.status === true)
		.map((poi) => ({
			value: poi.id,
			label: poi.name,
		}));

	const handleSelect = async (poiId, scope) => {
		try {
			await addShiftPois({
				technicianId,
				poiIds: [poiId],
				scope,
			}).unwrap();

			if (scope === "START_ONLY") {
				setSelectedStartPois((prev) => [...prev, poiId]);
				refetchStart();
			} else {
				setSelectedEndPois((prev) => [...prev, poiId]);
				refetchEnd();
			}

			toast.success(trans("POI linked successfully"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar",
			});
		} catch (error) {
			console.error(error);
			toast.error(
				error?.data?.message || trans("Failed to link POI"),
				{
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar",
				}
			);
		}
	};

	const handleDeselect = async (poiId, scope) => {
		try {
			await removeShiftPoi({
				technicianId,
				poiId,
			}).unwrap();

			if (scope === "START_ONLY") {
				setSelectedStartPois((prev) => prev.filter((id) => id !== poiId));
				refetchStart();
			} else {
				setSelectedEndPois((prev) => prev.filter((id) => id !== poiId));
				refetchEnd();
			}

			toast.success(trans("POI removed successfully"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar",
			});
		} catch (error) {
			console.error(error);
			toast.error(
				error?.data?.message || trans("Failed to remove POI"),
				{
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar",
				}
			);
		}
	};

	return (
		<Popup show={!!technicianId} size="lg" style={"popup-bodyscroll"}>
			<Modal.Header className="modal-header flex-between">
				<Modal.Title id="contained-modal-title-vcenter">
					<PopupTitle
						headtitle={name || trans("Config Shift")}
						subtitle={trans(
							"Configure start and end shift POI locations for this technician."
						)}
					/>
				</Modal.Title>
				<Close
					style="close-32 close"
					close={onClose}
					img="Close"
				/>
			</Modal.Header>
			<Modal.Body className="modal-body-scrollable">
				<div className="mb-3">
					<div className="mult-input-label">
						{trans("Start Shift POI")}
					</div>
					<Space style={{ width: "100%" }} direction="vertical">
						<Select
							mode="multiple"
							style={{ width: "100%", marginTop: "8px" }}
							maxTagCount="responsive"
							placeholder={trans("Please select")}
							onSelect={(value) => handleSelect(value, "START_ONLY")}
							onDeselect={(value) => handleDeselect(value, "START_ONLY")}
							value={selectedStartPois}
							options={poiOptions}
							filterOption={(input, option) =>
								option.label.toLowerCase().includes(input.toLowerCase())
							}
						/>
					</Space>
				</div>

				<div className="mb-3">
					<div className="mult-input-label">
						{trans("End Shift POI")}
					</div>
					<Space style={{ width: "100%" }} direction="vertical">
						<Select
							mode="multiple"
							style={{ width: "100%", marginTop: "8px" }}
							maxTagCount="responsive"
							placeholder={trans("Please select")}
							onSelect={(value) => handleSelect(value, "END_ONLY")}
							onDeselect={(value) => handleDeselect(value, "END_ONLY")}
							value={selectedEndPois}
							options={poiOptions}
							filterOption={(input, option) =>
								option.label.toLowerCase().includes(input.toLowerCase())
							}
						/>
					</Space>
				</div>
			</Modal.Body>
		</Popup>
	);
}
